module.exports = __webpack_public_path__ + "static/media/analyzeimage.6f8ac9a5.png";